import { YesNoBlank } from '@/__generated__/businessAnswerUpsertMutation.graphql';
import { CheckList, CheckListGroup } from '@/components/survey/common/ui';

interface Props<T> {
  answers: {
    value: T;
    label: string;
  }[];
  checkedValue: unknown;
  onChange: (value: T) => void;
}

export const AnswerList = <T = YesNoBlank,>({ answers, checkedValue, onChange }: Props<T>) => {
  return (
    <CheckListGroup>
      {answers.map(({ value, label }) => (
        <CheckList key={value as string} value={value as string} checked={checkedValue === value} onChange={() => onChange(value)}>
          {label}
        </CheckList>
      ))}
    </CheckListGroup>
  );
};
